import {
  AddOneSlotToLoadingQueue,
  RemoveOneSlotToLoadingQueue,
} from "../../loading/loading.store";
import ShowNotification from "../../../../components/react-notifications/react-notifications";
import { NotificationMessageType } from "../../../../utils/configuration";
import { ApiUrl } from "../../../../api/api-url";
import Service from "../../../../api/api-service";
import { CONSTANT } from "../../../../constants/constant";
const service = new Service();

export const GET_LOOKUP_DOCUMENT_TYPE_OK = "GET_LOOKUP_DOCUMENT_TYPE_OK";
export const GET_LOOKUP_DOCUMENT_TYPE_ERR = "GET_LOOKUP_DOCUMENT_TYPE_ERR";

export const lookupDocumentTypeAction = {
  getLookupDocumentType,
};

function getLookupDocumentTypeOk(payload) {
  return { type: GET_LOOKUP_DOCUMENT_TYPE_OK, payload };
}
function getLookupDocumentTypeErr(payload) {
  return { type: GET_LOOKUP_DOCUMENT_TYPE_ERR, payload };
}

function getLookupDocumentType(data) {
  return function (dispatch) {
    dispatch(AddOneSlotToLoadingQueue);
    return service
      .get(ApiUrl.GetLookupDocumentType)
      .then((response) => {
        dispatch(getLookupDocumentTypeOk(response));
        dispatch(RemoveOneSlotToLoadingQueue);
      })
      .catch((error) => {
        dispatch(getLookupDocumentTypeErr(error));
        dispatch(RemoveOneSlotToLoadingQueue);
        if (error && error.errorMessage) {
          ShowNotification(error.errorMessage, NotificationMessageType.Error);
        } else {
          ShowNotification(
            CONSTANT.message.error_unknown,
            NotificationMessageType.Error
          );
        }
      });
  };
}
